import { makeQuery } from 'shared/utilities';
import { IDepartmentModel } from 'shared/models';

type ResponseType = {
    items: IDepartmentModel[];
};

export const departmentsQuery = async function () {
    return await makeQuery<ResponseType>('/departments');
}
